import { combineReducers } from '@reduxjs/toolkit';

import { uploadProgressReducer } from './uploadProgressSlice';

export const uploadProgressReducerMain = combineReducers({
    progress: uploadProgressReducer,
});
